import axios from 'axios';

// Create axios instance
const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://bizlinks.in/api',
});

// ─── Request Interceptor ────────────────────────────────────────────────────
api.interceptors.request.use(
    (config) => {
        const token = sessionStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        const activeRole = sessionStorage.getItem('activeRole');
        if (activeRole) {
            config.headers['X-Active-Role'] = activeRole;
        }

        // Support Super Admin accessing organization specific dashboard
        const pathParts = window.location.pathname.split('/').filter(Boolean);
        if (pathParts[0] === 'super-admin' && pathParts[1] === 'organizations' && pathParts[2] && pathParts[3] === 'dashboard') {
            config.headers['X-Org-Code'] = pathParts[2];
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// ─── Response Interceptor ───────────────────────────────────────────────────
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const requestUrl = error.config?.url || '';

            // Don't redirect if the 401 came from the verify check itself —
            // AuthContext handles that gracefully (shows login page via state).
            const isVerifyCall = requestUrl.includes('/auth/verify');

            // Clear all stored auth state
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('user');
            sessionStorage.removeItem('activeRole');
            // Keep orgContext so the login page can pre-fill the org branding

            if (!isVerifyCall && window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;

